import { useDraggable } from "@dnd-kit/core";
import { Order } from "@/redux/services/order/order.type";
import { cn } from "@/lib/utils";
import KdsOrderCard from "./KdsOrderCard";

interface DraggableOrderCardProps {
  order: Order;
  onItemStatusChange?: () => void;
}

const DraggableOrderCard: React.FC<DraggableOrderCardProps> = ({
  order,
  onItemStatusChange,
}) => {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: order.id,
  });

  return (
    <div ref={setNodeRef} className={cn(isDragging && "opacity-30")}>
      <KdsOrderCard
        order={order}
        onItemStatusChange={onItemStatusChange}
        dragHandleProps={{ listeners, attributes }}
      />
    </div>
  );
};

export default DraggableOrderCard;
